/**
 * Presenter remote emotes: layout modes (default corner vs last-slide “finale”).
 * Keeps magic numbers and spawn rules in one place for emote-toast + CSS variables.
 */

export type RemoteEmoteLayout = 'default' | 'last_slide';

/** Multiplier applied to base particle font size in finale layout (CSS var on burst). */
export const REMOTE_EMOTE_FINALE_SIZE_MULT = 2.35;

export interface EmoteParticleSpawn {
  count: number;
  leftPct: () => number;
  bottomPct: () => number;
  delayMax: number;
  durMin: number;
  durSpan: number;
  riseMin: number;
  riseSpan: number;
  dxMin: number;
  dxSpan: number;
  rotScale: number;
  jitterMin: number;
  jitterSpan: number;
}

export function remoteEmoteParticleSpawn(layout: RemoteEmoteLayout, boosted: boolean): EmoteParticleSpawn {
  if (layout === 'last_slide') {
    return boosted
      ? {
          count: 7,
          leftPct: () => 2 + Math.random() * 96,
          bottomPct: () => Math.random() * 8,
          delayMax: 1.1,
          durMin: 10,
          durSpan: 5,
          riseMin: 22,
          riseSpan: 28,
          dxMin: 4,
          dxSpan: 42,
          rotScale: 44,
          jitterMin: 0.85,
          jitterSpan: 0.45
        }
      : {
          count: 3,
          leftPct: () => 5 + Math.random() * 90,
          bottomPct: () => Math.random() * 8,
          delayMax: 0.45,
          durMin: 11,
          durSpan: 4.5,
          riseMin: 20,
          riseSpan: 26,
          dxMin: 5,
          dxSpan: 38,
          rotScale: 36,
          jitterMin: 0.9,
          jitterSpan: 0.35
        };
  }
  return boosted
    ? {
        count: 5,
        leftPct: () => 8 + Math.random() * 72,
        bottomPct: () => Math.random() * 18,
        delayMax: 0.95,
        durMin: 9,
        durSpan: 4.5,
        riseMin: 14,
        riseSpan: 18,
        dxMin: 6,
        dxSpan: 34,
        rotScale: 36,
        jitterMin: 0.78,
        jitterSpan: 0.35
      }
    : {
        count: 1,
        leftPct: () => 18 + Math.random() * 52,
        bottomPct: () => 4 + Math.random() * 14,
        delayMax: 0.2,
        durMin: 10,
        durSpan: 4,
        riseMin: 12,
        riseSpan: 16,
        dxMin: 4,
        dxSpan: 28,
        rotScale: 20,
        jitterMin: 0.92,
        jitterSpan: 0.2
      };
}
